// extracted by mini-css-extract-plugin
module.exports = {"trustpilotScore":"homepage_trustpilotScore__ul5D4","heading":"homepage_heading__5LlYT","valuePropsCardsContainer":"homepage_valuePropsCardsContainer__ifg_K"};